<template>
    <div>
        <VueMultiselect
            @remove="$emit('removeAttribute', $event)"
            @input="setAttributes"
            v-if="articleAttributes"
            :options="articleAttributes"
            multiple
            :placeholder="__('product.product_section.attributes_placeholder')"
            v-model="selectedAttributes"
            track-by="name"
            label="name"
        ></VueMultiselect>
        <small class="form-text text-muted">
            {{ __("product.product_section.article_attributes") }}
        </small>
    </div>
</template>

<script>
import VueMultiselect from "vue-multiselect";

export default {
    name: "ArticleAttributes",
    components: { VueMultiselect },
    data() {
        return {
            articleAttributes: null,
            selectedAttributes: null,
            placeholders: Array,
        };
    },
    methods: {
        async getAttributes() {
            let { data } = await axios.get(route("article-attributes"));
            this.articleAttributes = data;
            this.getPlaceholder();
        },
        setAttributes() {
            this.$emit("setAttributes", this.selectedAttributes);
        },
        getPlaceholder() {
            this.articleAttributes.forEach((attribute) => {
                switch (attribute.slug) {
                    case "groesse":
                        attribute.placeholder = "32";
                        break;
                    case "farbe":
                        attribute.placeholder = "Orange";
                        break;
                    case "gewicht":
                        attribute.placeholder = "2 kg";
                        break;
                    case "tiefe":
                        attribute.placeholder = "32 cm";
                        break;
                    case "hoehe":
                        attribute.placeholder = "2 cm";
                        break;
                    case "breite":
                        attribute.placeholder = "5 cm";
                        break;
                    case "material":
                        attribute.placeholder = "Polyester";
                        break;
                    case "geschlecht":
                        attribute.placeholder = "Unisex";
                        break;
                    default:
                        attribute.placeholder = attribute.name;
                }
            });
        },
    },
    async mounted() {
        await this.getAttributes();
    },
};
</script>
